import { render } from "./ViewGallery.vue?vue&type=template&id=fb0f4416&scoped=true"
import script from "./ViewGallery.vue?vue&type=script&lang=js"
export * from "./ViewGallery.vue?vue&type=script&lang=js"

import "./ViewGallery.vue?vue&type=style&index=0&id=fb0f4416&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb0f4416"]])

export default __exports__